export const projects = [
  {
    title: 'Agile Digital Mission Assurance Implementation',
    description:
      'Implemented agile-driven mission assurance solutions in a digital workspace to enhance operational efficiency and reliability. Developed centralized data repositories and custom analytical applications within Palantir Foundry, streamlining hardware lifecycle management and providing intuitive platforms for trend analysis, data filtering, and comparative assessments. Created reusable mission task templates in Jira for structured tracking of deliverables and anomalies, while integrating with Confluence and Mattermost for comprehensive statistical overviews and efficient real-time collaboration.',
    techstack: [
      'Palantir Foundry',
      'Jira',
      'Confluence',
      'Mattermost'
    ],
    imageSource: '/images/projects/mission-assurance.jpg'
  },
  {
    title: 'Spaceport Transportation Scheduling Tool',
    description:
      'Developed a secure, streamlined scheduling solution enabling commercial launch service providers to submit and manage transportation requests efficiently. Customized Microsoft Forms for secure request submission, employed SharePoint as a central hub with Microsoft Lists for dynamic data management, and leveraged Power Automate to automate critical workflows. Created automated, real-time dashboards and reports using Power BI, greatly enhancing leadership visibility and operational efficiency.',
    techstack: [
      'Microsoft SharePoint',
      'Microsoft Forms',
      'Microsoft Lists',
      'Power Automate',
      'Power BI'
    ],
    imageSource: '/images/projects/spaceport-scheduling.jpg'
  },
  {
    title: 'Common Operating Picture (COP) Feedback Pipeline',
    description:
      'Designed and implemented a structured feedback pipeline to support the pre-discovery phase of developing a Common Operating Picture (COP). Developed customized forms using Microsoft Forms to efficiently capture user insights, utilized SharePoint and Microsoft Lists for centralized data storage, and leveraged Power Automate to streamline data processing and validation. Created automated, interactive dashboards using Power BI to effectively visualize and communicate feedback results, aiding in strategic decision-making.',
    techstack: [
      'Microsoft SharePoint',
      'Microsoft Forms',
      'Microsoft Lists',
      'Power Automate',
      'Power BI'
    ],
    imageSource: '/images/projects/cop-feedback.jpg'
  },
  {
    title: 'Data Derby Hackathon: Ground Scheduling Prototype',
    description:
      'Participated in a week-long hackathon focused on developing an innovative prototype using Palantir Foundry. Our solution leveraged ground scheduling data and featured advanced functionalities, including route simulation, conflict resolution, and geospatial visualization. Innovatively utilized previously underused tool features, developed with integration and compatibility in mind, and quickly adjusted approaches based on live feedback. Recognized with the award for "Best Agility" at the conclusion of the hackathon.',
    techstack: [
      'Palantir Foundry',
      'Data Visualization',
      'Geospatial Analysis',
      'Prototype Development'
    ],
    imageSource: '/images/projects/data-derby.jpg'
  }
]; 